module.exports = __webpack_public_path__ + "img/Wigo_icons_redesign_fuel_card.c1af873e.svg";